<template>
  <ModalStructure
    class="modal"
    :hasBlur="false"
    :shouldCloseOnBlur="false"
    :showModal="showResultsModal"
    showCloseButton
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingLarge class="header">
        <ApplicationAvatar />
        <div class="header__title">
          Import in Progress
        </div>
      </HeadingLarge>
    </template>
    <template v-slot:body>
      <HeadingSmall>
        {{ successMessage }}
      </HeadingSmall>
      <Card
        class="card"
      >
        <template v-slot:header>
          <HeadingSmall>
            Job Details
          </HeadingSmall>
        </template>
        <template v-slot:body>
          <ParagraphBody>
            <b> Job ID: </b> {{ resultsJobId }}
          </ParagraphBody>
        </template>
      </Card>
    </template>
    <template
      v-slot:footer
    >
      <div
        class="footer"
      >
        <HeadingSmall
          class="tips__title"
        >
          Helpful Tips
        </HeadingSmall>
        <ParagraphBody>
          {{ infoGroupsMessage }}
        </ParagraphBody>
        <div
          class="cards"
        >
          <Card
            class="card"
          >
            <template v-slot:header>
              <HeadingExtraSmall>
                Manage User Attributes & Assign Resources
              </HeadingExtraSmall>
            </template>
            <template v-slot:body>
              <ParagraphBody>
                Manage user attributes, assign a device or directory, or add to a user group.
              </ParagraphBody>
            </template>
            <template v-slot:footer>
              <Link
                :href="userRoute"
                text="Go to Users"
                @click.native="handleClose"
              />
            </template>
          </Card>
          <Card
            class="card"
          >
            <template v-slot:header>
              <HeadingExtraSmall>
                Add Users to User Groups
              </HeadingExtraSmall>
            </template>
            <template v-slot:body>
              <ParagraphBody>
                Assign user groups to give users the correct access to the resources they need
              </ParagraphBody>
            </template>
            <template v-slot:footer>
              <Link
                :href="userGroupRoute"
                text="Go to Users Groups"
                @click.native="handleClose"
              />
            </template>
          </Card>
          <Card
            class="card"
          >
            <template v-slot:header>
              <HeadingExtraSmall>
                Add Users to Device Groups
              </HeadingExtraSmall>
            </template>
            <template v-slot:body>
              <ParagraphBody>
                Assign device groups to give users the right level of access to multiple devices
              </ParagraphBody>
            </template>
            <template v-slot:footer>
              <Link
                :href="deviceGroupRoute"
                text="Go to Device Groups"
                @click.native="handleClose"
              />
            </template>
          </Card>
        </div>
      </div>
    </template>
  </ModalStructure>
</template>

<script>
import {
  Card,
  HeadingExtraSmall,
  HeadingLarge,
  HeadingSmall,
  Link,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import ApplicationAvatar from 'client/applications/ApplicationAvatar.vue';

export default {
  name: 'IdmUsersImportResults',

  components: {
    ApplicationAvatar,
    Card,
    HeadingLarge,
    HeadingSmall,
    HeadingExtraSmall,
    Link,
    ModalStructure,
    ParagraphBody,
  },

  props: {
    displayName: {
      type: String,
      default: '',
    },

    resultsJobId: {
      type: String,
      default: '',
    },

    showResultsModal: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      deviceGroupRoute: ItemTypeRoutes[ItemTypeConsts.deviceGroup],
      userGroupRoute: ItemTypeRoutes[ItemTypeConsts.userGroup],
      userRoute: ItemTypeRoutes[ItemTypeConsts.systemUser],
    };
  },

  computed: {
    infoGroupsMessage() {
      return `Users must be members of a user group connected to ${this.displayName} to in order to manage access to single sign on and, if supported, user identity management.`;
    },

    successMessage() {
      return 'The import has successfully started. An email will be sent with the results once complete.';
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },
  },

};
</script>

<style scoped>
.modal {
  --modal-width: 130ch;
}

.header {
  align-items: center;
  border-bottom: 1px solid #e3e8e9;
  display: flex;
  padding-bottom: var(--jc-spacer-small);
}

.header__title {
  margin-left: var(--jc-spacer);
}

.tips__title {
  margin-top: 12px;
}

.footer {
  border-top: 1px solid #e3e8e9;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.cards {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  width: 324px;
}
</style>
